import { configureStore } from "@reduxjs/toolkit";
import staffReducer from './StaffReducer/staffSlice'
import affRedducer from './AffReducer/affSlice'


export const store = configureStore({
    reducer: {
        'staff':staffReducer,
        'aff':affRedducer
    }
})